module.exports = __webpack_public_path__ + "static/img/mo.04fdd78.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/mo.jpg
// module id = sufx
// module chunks = 0